// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'
import VSwipe from 'vswipe'
import * as Sentry from '@sentry/browser';

Sentry.init({ dsn: 'https://109a23d6d80b422cbef436e0284177d1@sentry.ops.nuvoair.com/6' });

Vue.use(BootstrapVue);
Vue.use(VSwipe);

window.axios = require('axios');
window.Sentry = require('@sentry/browser');

library.add(faChevronRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  components: { App },
  template: '<App />'
});

global.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js